import { render, staticRenderFns } from "./PaperclipWidget.vue?vue&type=template&id=8295ac90&"
import script from "./PaperclipWidget.vue?vue&type=script&lang=ts&"
export * from "./PaperclipWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports